export default __webpack_public_path__ + "static/media/08_photo.dd00c884.jpg";